import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import GameCategories from "./components/GameCategories";
import Features from "./components/Features";
import Promotions from "./components/Promotions";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "必赢亚洲",
  "url": "https://www.biyingyazhou.com/",
  "description": "必赢亚洲是亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。",
  "inLanguage": "zh-CN",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.biyingyazhou.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "必赢亚洲",
  "url": "https://www.biyingyazhou.com/",
  "description": "亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。",
  "foundingDate": "2015",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+63-2-8888-6666",
    "contactType": "customer service",
    "availableLanguage": ["Chinese"],
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "如何注册必赢亚洲账号？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "点击页面右上角的「立即注册」按钮，填写手机号码、设置登录密码，完成短信验证即可成功注册。整个注册过程只需1分钟，简单快捷。",
      },
    },
    {
      "@type": "Question",
      "name": "必赢亚洲支持哪些充值方式？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "我们支持多种主流充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等，满足不同用户的支付习惯，充值实时到账。",
      },
    },
    {
      "@type": "Question",
      "name": "提现需要多久到账？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "必赢亚洲采用智能审核系统，小额提现通常在5分钟内到账，大额提现经人工审核后30分钟内到账。",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="必赢亚洲·官方正版平台 - 安全畅玩赢无止境"
        description="必赢亚洲是亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。必赢亚洲官方正版授权，安全存取款，极速到账，24小时客服全程护航。"
        keywords="必赢亚洲,必赢亚洲官网,必赢亚洲注册,必赢亚洲登录入口,必赢亚洲体育投注,必赢亚洲真人娱乐,必赢亚洲优惠活动"
        canonicalUrl="https://www.biyingyazhou.com/"
      />
      <SchemaOrg data={homeSchema} />
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={faqSchema} />

      <main>
        <HeroSection />
        <GameCategories />
        <Features />
        <Promotions />
        <Testimonials />
        <FAQ />
      </main>
    </>
  );
}